import { VStack as NbVStack } from 'native-base';

import { addWithConfig } from '../../utils';

export const VStack = NbVStack;

export default addWithConfig(VStack);
